import React, { useCallback, useMemo, useEffect } from 'react'
import classes from './Modal.module.css'
import classNames from 'classnames'
import { createPortal } from 'react-dom'

const modalRoot = document.getElementById('modal-root')

const Modal = ({
    open,
    className,
    onRequestDismiss,
    allowDismiss = true,
    children,
    ...props
}) => {
    const hideIfAllowed = useCallback(() => {
        if (allowDismiss && onRequestDismiss) {
            onRequestDismiss()
        }
    }, [onRequestDismiss, allowDismiss])
    const el = useMemo(() => document.createElement('div'), [])

    const trapEvent = handler => event => {
        event.stopPropagation()
        !!handler && handler(event)
    }

    // All of this magic is to ensure we can have multiple modal instances
    // on the same page
    useEffect(() => {
        modalRoot.appendChild(el)
        return () => modalRoot.removeChild(el)
    }, [el])

    return createPortal(
        <div
            className={classNames(classes.Modal, open && classes.ModalOpen)}
            {...props}
            onClick={trapEvent(hideIfAllowed)}
            onKeyDown={trapEvent(event => {
                if (event.keyCode === 27) {
                    hideIfAllowed()
                }
            })}
        >
            <div
                className={classNames(
                    classes.ModalBody,
                    className,
                    open && classes.ModalBodyOpen
                )}
                onClick={trapEvent()}
            >
                {children}
            </div>
        </div>,
        el
    )
}

export default Modal
